module.exports = {"pathContext":{"name":"TreatmentTimeIntervalInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"begin","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"end","type":{"kind":"SCALAR","name":"DateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-treatment-time-interval-input.json
// module id = 1586
// module chunks = 221813830287272